module.exports = __webpack_public_path__ + "img/0035.871bce08.gif";